import logo from '../../assets/images/miamr_logo.png';

const HeaderLogo = () => {
  return (
    <div className="flex items-center  pr-6">
      <img src={logo} alt="logo" className="h-12 object-contain" />
    </div>
  );
};

export default HeaderLogo;
